import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
const baseHubSpotUrl = getFullUrl('app');
const portalId = PortalIdParser.get();
export const getSnippetsUrl = () => {
  return `${baseHubSpotUrl}/snippets/${portalId}`;
};
export const getNewSnippetsUrl = () => {
  return `${baseHubSpotUrl}/snippets/${portalId}/new`;
};